import { SITE_VARIABLES } from '../../../common/styles/variables';
import { PlayerSizesTypes } from '../../../common/store/store.types';

interface StylesObject {
  containerStyle: { [key: string]: any };
  titleStyle: { [key: string]: any };
}

const title = {
  fontFamily: SITE_VARIABLES.TEXT_FONT_FAMILY.LATO,
  fontWeight: '300',
  color: SITE_VARIABLES.COLORS.WHITE,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  fontSize: SITE_VARIABLES.FONT_SIZE.SMALL,
  display: 'block',
  small: {
    margin: '0px 6px',
  },
  big: {
    margin: '0px 8px',
  },
};

const container = {
  width: '100%',
  position: 'relative',
  display: 'grid',
};

export const getTitleStyleObject = (playerSize: PlayerSizesTypes): StylesObject => {
  const extraSmallAndSmallSize = playerSize === 'extraSmall' || playerSize === 'small';
  const mediumSize = playerSize === 'medium';
  const largeAndExtraLargeSize = playerSize === 'large' || playerSize === 'extraLarge';
  return ({
    containerStyle: {
      ...container,
    },
    titleStyle: [
      title,
      (extraSmallAndSmallSize || mediumSize) && title.small,
      largeAndExtraLargeSize && title.big,
    ],
  });
};
